module.exports = __webpack_public_path__ + "static/media/play-store.8656e97e.png";